export enum AdvanceBookingType {
	None = 0,
	One = 1,
	Two = 2,
	Three = 3,
	Five = 5,
	Seven = 7,
	Fourteen = 14,
	Thirty = 30
}
